/**
 * Switchboard API adapter for web-app
 *
 * Uses the shared MangoApiClient's authenticated transport. All requests flow
 * through the same auth refresh/rate-limit interceptor stack.
 */
import { getMangoApiClient } from '~/atoms/MangoApi'

import { createSwitchboardApi } from '@mangovoice/switchboard-ui'

export const switchboardApi = createSwitchboardApi(
  getMangoApiClient().switchboard,
)
